import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { DiscountModel } from '~/models/DiscountModel';
import { LineItemType } from '~/models/invoice-draft/model';
import * as timeModel from '~/models/time';
import { AvailableCreditModel } from '../AvailableCreditModel';
export function fromDTO(invoiceDraftDTO) {
    var _invoiceDraftDTO_attachments;
    const { issueDate, paymentDate, totalAmount } = invoiceDraftDTO;
    const credits = invoiceDraftDTO.credits.map((c)=>new AvailableCreditModel(c));
    const lineItems = invoiceDraftDTO.lineItems.map(lineItemFromDTO);
    return {
        attachments: (_invoiceDraftDTO_attachments = invoiceDraftDTO.attachments) !== null && _invoiceDraftDTO_attachments !== void 0 ? _invoiceDraftDTO_attachments : [],
        issueDate: timeModel.fromDateStampObject(issueDate),
        paymentDate: timeModel.fromDateStampObject(paymentDate),
        totalAmount: new Decimal(totalAmount).div(100).toDP(),
        credits,
        lineItems
    };
}
function subLineItemsFromDTO(dto) {
    return dto === null || dto === void 0 ? void 0 : dto.map((subLineItem)=>({
            name: subLineItem.name,
            discount: DiscountModel.fromDTO(subLineItem.discount),
            totalAmount: new Decimal(subLineItem.totalAmount).div(100).toDP(),
            rate: {
                unit: subLineItem.rate.unit,
                amount: new Decimal(subLineItem.rate.amount).div(100).toDP()
            },
            origin: subLineItem.origin ? {
                type: 'serviceBundle',
                serviceBundle: {
                    bundleItemId: subLineItem.origin.serviceBundle.bundleItemId,
                    serviceTemplateId: subLineItem.origin.serviceBundle.serviceTemplateId
                }
            } : undefined
        }));
}
function subLineItemsToDTO(subLineItems) {
    return subLineItems === null || subLineItems === void 0 ? void 0 : subLineItems.map((subLineItem)=>({
            name: subLineItem.name,
            discount: subLineItem.discount ? subLineItem.discount.toDTO() : null,
            totalAmount: subLineItem.totalAmount.mul(100).toNumber(),
            rate: {
                unit: subLineItem.rate.unit,
                amount: subLineItem.rate.amount.mul(100).toNumber()
            },
            origin: subLineItem.origin ? {
                type: 'serviceBundle',
                serviceBundle: {
                    bundleItemId: subLineItem.origin.serviceBundle.bundleItemId,
                    serviceTemplateId: subLineItem.origin.serviceBundle.serviceTemplateId
                }
            } : undefined
        }));
}
export function lineItemFromDTO(dto) {
    switch(dto.source){
        case LineItemType.Automatic:
            {
                return _object_spread_props(_object_spread({}, dto), {
                    source: LineItemType.Automatic,
                    totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
                    rate: _object_spread_props(_object_spread({}, dto.rate), {
                        amount: new Decimal(dto.rate.amount).div(100).toDP()
                    }),
                    automatic: _object_spread_props(_object_spread({}, dto.automatic), {
                        discount: DiscountModel.fromDTO(dto.automatic.discount)
                    }),
                    subLineItems: subLineItemsFromDTO(dto.subLineItems)
                });
            }
        case LineItemType.Manual:
            {
                return _object_spread_props(_object_spread({}, dto), {
                    source: LineItemType.Manual,
                    totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
                    rate: _object_spread_props(_object_spread({}, dto.rate), {
                        amount: new Decimal(dto.rate.amount).div(100).toDP()
                    }),
                    manual: _object_spread_props(_object_spread({}, dto.manual), {
                        quantity: dto.manual.quantity ? new Decimal(dto.manual.quantity).div(100).toDP() : null,
                        discount: DiscountModel.fromDTO(dto.manual.discount)
                    }),
                    subLineItems: subLineItemsFromDTO(dto.subLineItems)
                });
            }
        case LineItemType.AdHocCharge:
            {
                return _object_spread_props(_object_spread({}, dto), {
                    source: LineItemType.AdHocCharge,
                    totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
                    rate: _object_spread_props(_object_spread({}, dto.rate), {
                        amount: new Decimal(dto.rate.amount).div(100).toDP()
                    }),
                    adHocCharge: _object_spread_props(_object_spread({}, dto.adHocCharge), {
                        quantity: new Decimal(dto.adHocCharge.quantity).div(100).toDP(),
                        discount: DiscountModel.fromDTO(dto.adHocCharge.discount)
                    })
                });
            }
        case LineItemType.Credit:
            {
                return _object_spread_props(_object_spread({}, dto), {
                    source: LineItemType.Credit,
                    totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
                    rate: _object_spread_props(_object_spread({}, dto.rate), {
                        amount: new Decimal(dto.rate.amount).div(100).toDP()
                    })
                });
            }
        default:
            {
                throw new Error('unrecognized line item source');
            }
    }
}
export function toDTO(invoiceDraft) {
    const { issueDate, paymentDate, totalAmount } = invoiceDraft;
    const credits = invoiceDraft.credits.map((c)=>c.toJSON());
    const lineItems = invoiceDraft.lineItems.map(lineItemToDTO);
    return {
        attachments: invoiceDraft.attachments,
        issueDate: timeModel.toDateStampObject(issueDate),
        paymentDate: timeModel.toDateStampObject(paymentDate),
        totalAmount: totalAmount.mul(100).toNumber(),
        credits,
        lineItems
    };
}
export function lineItemToDTO(lineItem) {
    switch(lineItem.source){
        case LineItemType.Automatic:
            {
                return _object_spread_props(_object_spread({}, lineItem), {
                    source: LineItemType.Automatic,
                    totalAmount: lineItem.totalAmount.mul(100).toNumber(),
                    rate: _object_spread_props(_object_spread({}, lineItem.rate), {
                        amount: lineItem.rate.amount.mul(100).toNumber()
                    }),
                    automatic: _object_spread_props(_object_spread({}, lineItem.automatic), {
                        discount: lineItem.automatic.discount && lineItem.automatic.discount.toDTO()
                    }),
                    subLineItems: subLineItemsToDTO(lineItem.subLineItems)
                });
            }
        case LineItemType.Manual:
            {
                return _object_spread_props(_object_spread({}, lineItem), {
                    source: LineItemType.Manual,
                    totalAmount: lineItem.totalAmount.mul(100).toNumber(),
                    rate: _object_spread_props(_object_spread({}, lineItem.rate), {
                        amount: lineItem.rate.amount.mul(100).toNumber()
                    }),
                    manual: _object_spread_props(_object_spread({}, lineItem.manual), {
                        quantity: lineItem.manual.quantity !== null ? lineItem.manual.quantity.mul(100).toNumber() : null,
                        discount: lineItem.manual.discount && lineItem.manual.discount.toDTO()
                    }),
                    subLineItems: subLineItemsToDTO(lineItem.subLineItems)
                });
            }
        case LineItemType.AdHocCharge:
            {
                return _object_spread_props(_object_spread({}, lineItem), {
                    source: LineItemType.AdHocCharge,
                    totalAmount: lineItem.totalAmount.mul(100).toNumber(),
                    rate: _object_spread_props(_object_spread({}, lineItem.rate), {
                        amount: lineItem.rate.amount.mul(100).toNumber()
                    }),
                    adHocCharge: _object_spread_props(_object_spread({}, lineItem.adHocCharge), {
                        quantity: lineItem.adHocCharge.quantity.mul(100).toNumber(),
                        discount: lineItem.adHocCharge.discount && lineItem.adHocCharge.discount.toDTO()
                    })
                });
            }
        case LineItemType.Credit:
            {
                return _object_spread_props(_object_spread({}, lineItem), {
                    source: LineItemType.Credit,
                    totalAmount: lineItem.totalAmount.mul(100).toNumber(),
                    rate: _object_spread_props(_object_spread({}, lineItem.rate), {
                        amount: lineItem.rate.amount.mul(100).toNumber()
                    })
                });
            }
        default:
            {
                throw new Error('unrecognized line item source');
            }
    }
}
